import { createContext, useContext, useEffect, useState } from 'react';

const PageTitleContext = createContext();

const PageTitleProvider = ({ children }) => {
  const [pageTitle, setPageTitle] = useState('');

  return <PageTitleContext.Provider value={{ pageTitle, setPageTitle }}>{children}</PageTitleContext.Provider>;
};

const usePageTitleContext = () => useContext(PageTitleContext);

const usePageTitle = (title) => {
  const { setPageTitle } = usePageTitleContext();

  useEffect(() => {
    if (title) {
      document.title = `${title} – LoveInvoice`;
      setPageTitle(title);
    }

    return () => setPageTitle('');
  }, [title, setPageTitle]);
};

export { PageTitleProvider, usePageTitle, usePageTitleContext };
